import { createContext, useEffect, useState } from 'react';
import { syncAuthSession } from '../api/axios';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {

    const [auth, setAuth] = useState({});

    useEffect(() => {
        syncAuthSession(auth, setAuth);
    }, [auth]);

    return (

        <AuthContext.Provider value={{ auth, setAuth }}>
            {children}
        </AuthContext.Provider>


    )

}

export default AuthContext;
